export class CherryPickHelper {
    constructor(attrComputer, attributes = {}) {
        this.attrComputer = attrComputer;
        this.attributes = attributes;
        this.lostAttributes = {};
    }
    reset() {
        this.attributes = {};
        this.lostAttributes = {};
    }
    hasLostAttributeValue(attributeName, attributeValue) {
        var _a;
        if (this.hasLostAttribute(attributeName)) {
            if (this.attrComputer.isMultiValue(attributeName)) {
                const lostValues = (_a = this.getLostAttribute(attributeName)) !== null && _a !== void 0 ? _a : [];
                const attributeValues = Array.isArray(attributeValue) ? attributeValue : [attributeValue];
                return attributeValues.some((value) => lostValues.includes(value));
            }
            return this.getLostAttribute(attributeName) != attributeValue;
        }
        return false;
    }
    hasLostAttribute(attributeName) {
        return this.lostAttributes.hasOwnProperty(attributeName);
    }
    maybeRegisterALost(attributeName, attributeValue) {
        var _a;
        if (this.hasAttribute(attributeName)) {
            if (this.attrComputer.isMultiValue(attributeName)) {
                const cherryPickedValue = (_a = this.getAttribute(attributeName)) !== null && _a !== void 0 ? _a : [];
                const attributeValues = Array.isArray(attributeValue) ? attributeValue : [attributeValue];
                const lostValues = cherryPickedValue.filter((value) => !attributeValues.includes(value));
                if (lostValues.length) {
                    this.lostAttributes[attributeName] = lostValues;
                    return true;
                }
                else {
                    delete this.lostAttributes[attributeName];
                }
            }
            else {
                // TODO: Doesn't work for features (multi value)
                const cherryPickedValue = this.getAttribute(attributeName);
                const cherryPickedValueAsString = JSON.stringify(cherryPickedValue);
                const attributeValueAsString = JSON.stringify(attributeValue);
                if (cherryPickedValue !== undefined && cherryPickedValueAsString != attributeValueAsString) {
                    this.lostAttributes[attributeName] = cherryPickedValue;
                    return true;
                }
                else if (this.hasLostAttribute(attributeName)) {
                    delete this.lostAttributes[attributeName];
                }
            }
        }
        return false;
    }
    removeAttribute(attributeName, attributeValue) {
        var _a;
        if (this.hasAttribute(attributeName)) {
            if (this.attrComputer.isMultiValue(attributeName)) {
                const attributeValues = (_a = this.getAttribute(attributeName)) !== null && _a !== void 0 ? _a : [];
                this.attributes[attributeName] = attributeValues.filter((value) => value != attributeValue);
            }
            else {
                delete this.attributes[attributeName];
            }
        }
    }
    hasAttribute(attributeName) {
        return this.attributes.hasOwnProperty(attributeName);
    }
    setAttributes(attributes) {
        this.attributes = attributes;
    }
    setAttribute(attributeName, attributeValue) {
        var _a;
        // TODO: Make sure it keeps track of multi values: Example, when selecting both backpaper printing and effect layer it seems to just remembed the last picked one?
        if (this.attrComputer.isMultiValue(attributeName)) {
            if (!this.hasAttribute(attributeName)) {
                this.attributes[attributeName] = [];
            }
            (_a = this.getAttribute(attributeName)) === null || _a === void 0 ? void 0 : _a.push(attributeValue);
        }
        else {
            this.attributes[attributeName] = attributeValue;
        }
    }
    getAttribute(attributeName) {
        return this.attributes[attributeName];
    }
    getLostAttribute(attributeName) {
        return this.lostAttributes[attributeName];
    }
    getLostAttributes() {
        return this.lostAttributes;
    }
    getAttributes() {
        return this.attributes;
    }
}
